/* @jsx h */
import { defineComponent, h } from "vue";
import { LemmonModal } from "@app/vue/components/index";
import { useLocalization } from "@lemmonhq/uikit";

export type LeavePartPaidConfirmModalProps = {
  /** Formatted amount already collected across the split's legs. */
  collected: string;
  onConfirm: () => void;
  onCancel: () => void;
};

// Asked when the cashier tries to leave a split checkout that already has a
// collected leg. Leaving never discards money (the checkout is retained open
// and recoverable from Transaction History), but walking away mid-split is
// usually a mistake, so we make it a deliberate choice.
export const LeavePartPaidConfirmModal =
  defineComponent<LeavePartPaidConfirmModalProps>({
    name: "LeavePartPaidConfirmModal",
    props: ["collected", "onConfirm", "onCancel"],
    setup(props) {
      const { t } = useLocalization();

      return () => (
        <LemmonModal
          title={t("checkout.leave_part_paid.title")}
          onClose={props.onCancel}
          renderButtons={() => (
            <div class="p-3 lg:p-4 border-t flex justify-end gap-2">
              <button class="btn btn-neutral" onClick={props.onCancel}>
                {t("checkout.leave_part_paid.stay")}
              </button>
              <button class="btn btn-warning" onClick={props.onConfirm}>
                {t("checkout.leave_part_paid.leave")}
              </button>
            </div>
          )}
        >
          <div class="p-4 flex flex-col gap-2 text-base-content">
            <p>{t("checkout.leave_part_paid.body", [props.collected])}</p>
            <p class="text-sm text-base-content/70">
              {t("checkout.leave_part_paid.hint")}
            </p>
          </div>
        </LemmonModal>
      );
    },
  });
